const isDev = process.env.NODE_ENV === 'development'

export default {
    // 开发环境走 devServer 代理，避免浏览器跨域
    baseApi: isDev ? '' : (process.env.VUE_APP_URL || (window.location.protocol + "//" + window.location.host)),
    baseApiB: isDev ? '' : process.env.VUE_APP_BASE_API,
    tokenKey:process.env.VUE_APP_TOKEN ||'stargood_token',
    refreshTokenKey:process.env.VUE_APP_RE_TOKEN ||'stargood_refresh_token',
    tokenExpires:process.env.VITE_TOKEN_EXPIRES || 'token_expires',
}
